import visibleKey from '../getVisible/visibleKey';
import getVisible from '../getVisible/index.web';
export default (callBack, _rootTag) => {
    const listener = function () {
        callBack && callBack(getVisible(), {});
    };
    document.addEventListener(visibleKey.visibilityChangeKey, listener, false);
    return {
        remove() {
            document.removeEventListener(visibleKey.visibilityChangeKey, listener, false);
        },
    };
};
